var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoged)?_c('div',{staticClass:"content-panel color-scheme-dark login-area"},[_c('login')],1):_vm._e(),_vm._v(" "),(_vm.token)?_c('div',[_c('iframe',{staticClass:"iframe",attrs:{"src":'https://embed.tombalaklas.com/?token='+_vm.token+'&origin=https://'+_vm.api+'/'}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2beb4332","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/casino/tombola.vue
// module id = 1QeE
// module chunks = 0